export const FETCH_LOYALTY_REPORT_ACTION = 'app/Loyalty/FETCH_LOYALTY_REPORT_ACTION';
export const FETCH_LOYALTY_REPORT_SUCCESS_ACTION = 'app/Loyalty/FETCH_LOYALTY_REPORT_SUCCESS_ACTION';
export const FETCH_LOYALTY_REPORT_ERROR_ACTION = 'app/Loyalty/FETCH_LOYALTY_REPORT_ERROR_ACTION';

export const FETCH_LOYALTY_TREND_ACTION = 'app/Loyalty/FETCH_LOYALTY_TREND_ACTION';
export const FETCH_LOYALTY_TREND_SUCCESS_ACTION = 'app/Loyalty/FETCH_LOYALTY_TREND_SUCCESS_ACTION';
export const FETCH_LOYALTY_TREND_ERROR_ACTION = 'app/Loyalty/FETCH_LOYALTY_TREND_ERROR_ACTION';
